class MeruzyProjectInquiry extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.addEventListener('focusin', () => {
      if (this.started) return;
      this.started = true;
      this.track('meruzy_estimate_form_start');
    });
    this.form?.addEventListener('click', (event) => {
      if (!event.target.closest('button[type="submit"], input[type="submit"]')) return;
      if (!this.hasEligibleProjectValue()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showBudgetRequirementError();
        return;
      }
    }, true);
    this.form?.addEventListener('submit', (event) => this.validateAndTrack(event), true);
    this.addEventListener('change', (event) => {
      if (event.target.matches('#InquiryBudget')) this.clearBudgetRequirementError();
      if (event.target.matches('#InquiryProduct')) this.updateWindowMaterialField();
      if (event.target.closest('.meruzy-inquiry__uploader')) {
        this.track('meruzy_estimate_file_interaction');
      }
    });
    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    const productSelect = this.querySelector('#InquiryProduct');
    if (requestedProduct && productSelect) {
      const normalizedRequest = requestedProduct.replace(/-/g, ' ').toLowerCase();
      const requestTokens = normalizedRequest.split(' ').filter(Boolean);
      const matchingOption = [...productSelect.options].find((option) => requestTokens.every((token) => option.text.toLowerCase().includes(token)));
      if (matchingOption) productSelect.value = matchingOption.value;
    }
    this.updateWindowMaterialField();
  }

  updateWindowMaterialField() {
    const product = this.querySelector('#InquiryProduct');
    const wrapper = this.querySelector('[data-window-material-field]');
    const material = this.querySelector('#InquiryWindowMaterial');
    if (!product || !wrapper || !material) return;

    const isModernWindows = product.value.trim().toLowerCase() === 'modern windows';
    wrapper.hidden = !isModernWindows;
    material.disabled = !isModernWindows;
    material.required = isModernWindows;
    if (!isModernWindows) material.value = '';
  }

  track(event, detail = {}) {
    const product = this.querySelector('#InquiryProduct')?.value || new URLSearchParams(window.location.search).get('product') || 'unspecified';
    const payload = { event, product, ...detail };
    window.dispatchEvent(new CustomEvent('meruzy:conversion', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  validateAndTrack(event) {
    if (!this.hasEligibleProjectValue()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showBudgetRequirementError();
      return;
    }

    const hasUploadedFile = this.hasUploadedProjectFile();
    const sharedLink = this.querySelector('#InquiryFiles');
    const hasSharedLink = Boolean(sharedLink?.value.trim()) && sharedLink.checkValidity();
    this.track('meruzy_estimate_submit', {
      stage: 'single_page_inquiry',
      file_source: hasUploadedFile ? (hasSharedLink ? 'upload_and_link' : 'upload') : (hasSharedLink ? 'shared_link' : 'none')
    });
  }

  hasUploadedProjectFile() {
    const formData = new FormData(this.form);
    return formData.getAll('contact[Uploaded project files]').some((value) => {
      if (typeof value === 'string') return value.trim().length > 0;
      return value instanceof File && value.size > 0;
    });
  }

  hasEligibleProjectValue() {
    const budget = this.querySelector('#InquiryBudget');
    return Boolean(budget?.value) && !budget.value.toLowerCase().startsWith('under $500');
  }

  showBudgetRequirementError() {
    const budget = this.querySelector('#InquiryBudget');
    const error = this.querySelector('[data-project-budget-error]');
    if (error) error.hidden = false;
    budget?.setAttribute('aria-invalid', 'true');
    budget?.focus({ preventScroll: true });
    budget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  clearBudgetRequirementError() {
    const budget = this.querySelector('#InquiryBudget');
    const error = this.querySelector('[data-project-budget-error]');
    budget?.removeAttribute('aria-invalid');
    if (error) error.hidden = true;
  }

}

if (!customElements.get('meruzy-project-inquiry')) {
  customElements.define('meruzy-project-inquiry', MeruzyProjectInquiry);
}
